module.exports = __webpack_public_path__ + "img/plane-s.56b02502.png";